<template>
  <rabbey-base-drawer
    :title="`Detalles de Tarjeta`"
    @close="$emit('VisibleFalse')"
    :drawer="open"
    size="80%"
  >
    <h1 v-if="cargando">Cargando...</h1>
    <el-row>
      <el-form
        label-width="120px"
        :label-position="'top'"
        size="medium"
        v-if="!cargando"
      >
        <el-col>
          <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
            <el-form-item label="Proveedor">
              <div>
                <el-input :value="tarjeta.Nombre_Empresa" disabled />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
            <el-form-item label="Cliente">
              <div>
                <el-input :value="tarjeta.Nombre_Cliente" disabled />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
            <el-form-item label="Tarjeta Id">
              <div>
                <el-input :value="tarjeta.tarjetaid" disabled />
              </div>
            </el-form-item>
          </el-col>
        </el-col>
        <el-col>
          <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
            <el-form-item label="Balance">
              <div>
                <el-input :value="format(tarjeta.balance)" disabled />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
            <el-form-item label="Tipo consumo">
              <div>
                <el-input
                  :value="tarjeta.tipoconsumo == 'M' ? 'Monto' : 'Galones'"
                  disabled
                />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
            <el-form-item label="Estatus">
              <div>
                <el-input :value="tarjeta.status" disabled />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
            <el-form-item label="Asignacion">
              <div>
                <el-input :value="format(tarjeta.asignacion)" disabled />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
            <el-form-item label="Controlada">
              <div>
                <el-input
                  :value="tarjeta.controlada == 1 ? 'Si' : 'No'"
                  disabled
                />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
            <el-form-item label="Ulltima Recarga">
              <div>
                <el-input :value="tarjeta.ultima_recarga" disabled />
              </div>
            </el-form-item>
          </el-col>
        </el-col>
        <el-col>
          <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
            <el-form-item label="Balance">
              <div>
                <el-input :value="format(tarjeta.balance)" disabled />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
            <el-form-item label="Tipo consumo">
              <div>
                <el-input
                  :value="tarjeta.tipoconsumo == 'M' ? 'Monto' : 'Galones'"
                  disabled
                />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
            <el-form-item label="Estatus">
              <div>
                <el-input :value="tarjeta.status" disabled />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
            <el-form-item label="fecha ultimo consumo">
              <div>
                <el-input
                  :value="
                    new Date(tarjeta.fecha_ultimo_consumo).toLocaleDateString()
                  "
                  disabled
                />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
            <el-form-item label="Monto tope">
              <div>
                <el-input :value="format(tarjeta.monto_tope)" disabled />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" :md="8" :sm="24" :xs="24" class="col-p">
            <el-form-item label="Fecha ultima recarga">
              <div>
                <el-input
                  :value="
                    new Date(tarjeta.fecha_ultima_recarga).toLocaleDateString()
                  "
                  disabled
                />
              </div>
            </el-form-item>
          </el-col>
        </el-col>
      </el-form>
    </el-row>
  </rabbey-base-drawer>
</template>

<script>
export default {
  props: {
    tarjetaid: String,
    cliente: Number,
    proveedor: Number,
    open: Boolean
  },
  data() {
    return {
      tarjeta: null,
      cargando: false
    };
  },
  methods: {
    fetch() {
      this.cargando = true;
      this.$http
        .get(`/api/tennos/GetCardDetails/`, {
          params: {
            Tarjetaid: this.tarjetaid,
            ClienteId: this.cliente,
            Empresaid: this.proveedor
          }
        })
        .then((resp) => {
          this.tarjeta = resp.data[0];
          this.cargando = false;
        });
    },
    format(price) {
      return new Intl.NumberFormat("en-US").format(price);
    }
  },
  watch: {
    open(actual) {
      if (actual) {
        this.fetch();
      }
    }
  }
};
</script>

<style></style>
